
/* tslint:disable */
/* eslint-disable */
/**
 * Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface CatchUpAllUserAccountNumberRequest {
    dateFrom: string;
    dateTo: string;
    dryRun?: boolean;
}

export interface CatchUpUserAccountNumberByAccountIdRequest {
    accountId: string;
}

/**
 * 
 */
export class UserAccountNumberAdminApi extends runtime.BaseAPI {

    /**
     * Catch up all the UserAccountNumber from Account table
          */
    async catchUpAllUserAccountNumberRaw(requestParameters: CatchUpAllUserAccountNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['dateFrom'] == null) {
            throw new runtime.RequiredError(
                'dateFrom',
                'Required parameter "dateFrom" was null or undefined when calling catchUpAllUserAccountNumber().'
            );
        }

        if (requestParameters['dateTo'] == null) {
            throw new runtime.RequiredError(
                'dateTo',
                'Required parameter "dateTo" was null or undefined when calling catchUpAllUserAccountNumber().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dryRun'] != null) {
            queryParameters['dryRun'] = requestParameters['dryRun'];
        }

        if (requestParameters['dateFrom'] != null) {
            queryParameters['dateFrom'] = requestParameters['dateFrom'];
        }

        if (requestParameters['dateTo'] != null) {
            queryParameters['dateTo'] = requestParameters['dateTo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/registration/api/admin/user-account-number/catch-all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Catch up all the UserAccountNumber from Account table
          */
    async catchUpAllUserAccountNumber(requestParameters: CatchUpAllUserAccountNumberRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.catchUpAllUserAccountNumberRaw(requestParameters, initOverrides);
    }

    /**
     * Catch up one UserAccountNumber
          */
    async catchUpUserAccountNumberByAccountIdRaw(requestParameters: CatchUpUserAccountNumberByAccountIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling catchUpUserAccountNumberByAccountId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['accountId'] != null) {
            queryParameters['accountId'] = requestParameters['accountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/registration/api/admin/user-account-number/catch`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Catch up one UserAccountNumber
          */
    async catchUpUserAccountNumberByAccountId(requestParameters: CatchUpUserAccountNumberByAccountIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.catchUpUserAccountNumberByAccountIdRaw(requestParameters, initOverrides);
    }

}
